import type { IframeReturnVal } from '~/types/Iframe'

export const useIframeConfigStore = defineStore('iframeConfigStore', () => {
  const iframeConfig = ref<IframeReturnVal | null>(null)
  return { iframeConfig }
})
